export const companyInfo = {
  name: "Borer Busters",
  phone: "98210 22995",
  phoneFormatted: "+91 98210 22995",
  whatsappNumber: "919821022995",
  whatsappMessage: "Hi, I'd like to book a Borer Busters Visitation + Inspection + Estimation (₹1,999, waived off in 1st booking) for my home/office.",
  location: "South Mumbai",
  tagline: "Revolutionary Laser Treatment for Wood Borers",
  description: "Say goodbye to wood borers with our advanced laser technology. One treatment, durable results.",
  startingPrice: "4,999"
};

export const whatsappLink = `https://wa.me/919821022995?text=${encodeURIComponent("Hi, I'd like to book a Borer Busters Visitation + Inspection + Estimation (₹1,999, waived off in 1st booking) for my home/office.")}`;

export const heroContent = {
  badge: "South Mumbai's #1 Wood Borer Solution",
  headline: "Borer Busters",
  subheadline: "Laser-Based Wood Borer Treatment",
  tagline: "Immediately & durably destroys larvae and adult beetles all at once",
  highlight: "Which traditional pest control sprays and injections cannot!",
  cta: "Call Now to Book Inspection Visit"
};

export const keyBenefits = [
  "Destroys Larvae & Adults Instantly",
  "Effective & Durable Results",
  "Outperforms Traditional Sprays & Injections",
  "100% Chemical-Free Treatment",
  "No Evacuation Required"
];

export const problemStats = [
  { value: "80%", label: "of Mumbai homes affected by wood borers" },
  { value: "₹50K+", label: "average damage if left untreated" },
  { value: "3-5x", label: "traditional treatments need repeating" }
];

export const comparisonData = [
  {
    aspect: "Treatment Duration",
    laser: "One-time treatment",
    traditional: "Repeat treatments every 6-12 months"
  },
  {
    aspect: "Cost Structure",
    laser: "Single investment @ ₹4,999",
    traditional: "Ongoing AMC fees ₹3,000-5,000/year"
  },
  {
    aspect: "Effectiveness",
    laser: "Destroys larvae + adults instantly",
    traditional: "Partial kill, survivors breed again"
  },
  {
    aspect: "Coverage",
    laser: "100% universal penetration",
    traditional: "Limited to surface/injection points"
  },
  {
    aspect: "Wood Damage",
    laser: "Zero damage, non-invasive",
    traditional: "Drilling holes, chemical stains"
  },
  {
    aspect: "Chemical Exposure",
    laser: "100% chemical-free",
    traditional: "Toxic pesticides & fumes"
  },
  {
    aspect: "Evacuation Required",
    laser: "Stay at home during treatment",
    traditional: "Vacate for 24-48 hours"
  },
  {
    aspect: "Environment",
    laser: "Eco-friendly, safe for pets",
    traditional: "Harmful to environment & pets"
  }
];

export const benefits = [
  {
    icon: "Zap",
    title: "Instant Elimination",
    description: "Advanced laser technology destroys all life stages of wood borers immediately — eggs, larvae, and adults in one session."
  },
  {
    icon: "Shield",
    title: "Durable Results",
    description: "One session delivers long-lasting results. Precision laser eliminates larvae and adults where sprays and injections fail."
  },
  {
    icon: "Leaf",
    title: "100% Chemical-Free",
    description: "Pure laser energy treatment. Safe for your family, children, pets, and the environment."
  },
  {
    icon: "Home",
    title: "No Evacuation Needed",
    description: "Continue living in your home during treatment. No toxic fumes, no waiting period."
  },
  {
    icon: "Target",
    title: "Universal Coverage",
    description: "Laser penetrates deep into wood grain reaching borers that sprays and injections can never reach."
  },
  {
    icon: "BadgeCheck",
    title: "Zero Wood Damage",
    description: "Non-invasive treatment preserves your precious furniture. No drilling, no holes."
  }
];

export const howItWorks = [
  {
    step: "01",
    title: "Inspection Visit",
    description: "Book an on-site Visitation + Inspection + Estimation for ₹1,999. Our experts assess the infestation and provide a detailed quote — the fee is waived off against your first booking."
  },
  {
    step: "02",
    title: "Laser Treatment",
    description: "Precision laser technology eliminates all wood borers instantly and effectively."
  }
];

export const faqs = [
  {
    question: "How does laser treatment work on wood borers?",
    answer: "Our advanced laser system delivers precise energy that penetrates deep into the wood. This instantly eliminates wood borers at all life stages — eggs, larvae, and adult beetles — without damaging the wood structure."
  },
  {
    question: "What does ₹4,999 starting price include?",
    answer: "The ₹4,999 starting price covers laser treatment for a basic furniture item (like a chair, side table, or small cabinet). Larger items and multiple pieces are priced based on size and infestation level. Before treatment, we conduct an on-site Visitation + Inspection + Estimation for ₹1,999 — this fee is fully waived off against your first booking."
  },
  {
    question: "Is laser treatment safe for my furniture?",
    answer: "Absolutely! The laser is calibrated to target the borers without affecting the wood's structural integrity, finish, or appearance. Unlike chemical treatments, there are no stains, odors, or residue left behind."
  },
  {
    question: "Why is this better than traditional pest control?",
    answer: "Traditional sprays only reach surface borers, and injections have limited penetration. Our laser reaches every corner of the wood and eliminates borers instantly. Plus, it's a one-time treatment vs. repeated chemical applications that still leave survivors to breed."
  },
  {
    question: "Do I need to leave my home during treatment?",
    answer: "No! Since our treatment is 100% chemical-free, you can stay in your home throughout the process. There are no toxic fumes or waiting periods."
  },
  {
    question: "What areas in South Mumbai do you service?",
    answer: "We service all of South Mumbai including Colaba, Cuffe Parade, Nariman Point, Marine Drive, Malabar Hill, Breach Candy, Worli, Lower Parel, and surrounding areas."
  }
];

export const testimonials = [];


export const borerDamageImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/qw1gflww_WhatsApp%20Image%202026-02-17%20at%2000.25.57.jpeg",
    caption: "Fine wood dust (frass) near furniture joints"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/4z8krzhn_WhatsApp%20Image%202026-02-17%20at%2000.25.56%20%281%29.jpeg",
    caption: "Sawdust accumulation on floor beneath furniture"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/fdspsqfx_WhatsApp%20Image%202026-02-17%20at%2000.25.56.jpeg",
    caption: "Wood powder deposits indicating active infestation"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/imtgtn9o_WhatsApp%20Image%202026-02-17%20at%2000.26.42.jpeg",
    caption: "Characteristic borer exit holes with frass"
  }
];

export const disclaimer = {
  title: "Disclaimer",
  text: "While Borer Busters takes utmost care during laser treatment, we disclaim liability for any incidental damage that may occur to furniture, fixtures, or surrounding areas during the treatment process. Clients are advised to inform us of any particularly delicate or valuable items before treatment begins. Results may vary based on the extent of infestation and wood condition."
};
